import { UpdateScrapFinanceTradesAdditionsApi } from "@/features/accounts/scrap-finance/services/update-trades-additions-api";
import { UpdateScrapFinanceTradesAdditionsRequestModel } from "@/features/accounts/scrap-finance/services/update-trades-additions-model";

/// 銀行明細メモ・無効明細更新処理
export class UpdateScrapFinanceTradesAdditionsService {
  private updateScrapFinanceTradesAdditionsApi = new UpdateScrapFinanceTradesAdditionsApi();

  /**
   * 銀行明細メモ・無効明細更新API実行
   */
  public async updateScrapFinanceTradesAdditions(param: UpdateScrapFinanceTradesAdditionsRequestModel) {
    return await this.updateScrapFinanceTradesAdditionsApi.updateScrapFinanceTradesAdditions(param);
  }
}
